import request from "@/utils/request";

export function getHomeBanner() {
  return request({
    url: "/home/banner/list",
    method: "get",
    params: {
      position: 0
    }
  });
}

export function getVideoBanner() {
  return request({
    url: "/home/banner/list",
    method: "get",
    params: {
      position: 0
    }
  });
}
